<template>
  <div class="v2026-panelbar-tabs" role="tablist">
    <button type="button" class="v2026-panelbar-tab"
            :class="{ 'is-active': activeTab === 1, 'is-disabled': isDisabled(1) }"
            :disabled="isDisabled(1)" :aria-disabled="isDisabled(1) ? 'true' : null"
            :aria-selected="activeTab === 1" :aria-label="tabLabels.tab1" @click="onTab(1)">
      <span class="v2026-panelbar-mask v2026-panelbar-tab__ico" aria-hidden="true"
            :style="maskStyle(icons.user)"></span>
    </button>
    <button type="button" class="v2026-panelbar-tab"
            :class="{ 'is-active': activeTab === 2, 'is-disabled': isDisabled(2) }"
            :disabled="isDisabled(2)" :aria-disabled="isDisabled(2) ? 'true' : null"
            :aria-selected="activeTab === 2" :aria-label="tabLabels.tab2" @click="onTab(2)">
      <span class="v2026-panelbar-mask v2026-panelbar-tab__ico" aria-hidden="true"
            :style="maskStyle(icons.document)"></span>
    </button>
    <button v-if="showSchedule" type="button" class="v2026-panelbar-tab"
            :class="{ 'is-active': activeTab === 3, 'is-disabled': isDisabled(3) }"
            :disabled="isDisabled(3)" :aria-disabled="isDisabled(3) ? 'true' : null"
            :aria-selected="activeTab === 3" :aria-label="tabLabels.tab3" @click="onTab(3)">
      <span class="v2026-panelbar-mask v2026-panelbar-tab__ico" aria-hidden="true"
            :style="maskStyle(icons.bookmark)"></span>
    </button>
    <button v-if="showAi" type="button" class="v2026-panelbar-tab"
            :class="{ 'is-active': activeTab === 4, 'is-disabled': isDisabled(4) }"
            :disabled="isDisabled(4)" :aria-disabled="isDisabled(4) ? 'true' : null"
            :aria-selected="activeTab === 4" :aria-label="tabLabels.tab4" @click="onTab(4)">
      <span class="v2026-panelbar-mask v2026-panelbar-tab__ico" aria-hidden="true"
            :style="maskStyle(icons.sparkles)"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'panel-tab-bar-v2026',
  props: {
    activeTab: {
      type: Number,
      default: 1
    },
    showAi: {
      type: Boolean,
      default: true
    },
    showSchedule: {
      type: Boolean,
      default: true
    },
    // Empty by default so the other panels are untouched: Vue omits a falsy `disabled`, and an
    // aria-disabled bound to null is never written. The applicant rail passes [3, 4].
    disabledTabs: {
      type: Array,
      default: () => []
    },
    // Merged over the defaults so an omitted key can never render aria-label="undefined".
    labels: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      icons: {
        user: require('@/assets/icons2026/user.svg'),
        document: require('@/assets/icons2026/document.svg'),
        bookmark: require('@/assets/icons2026/bookmark-03.svg'),
        sparkles: require('@/assets/icons2026/ai-magic.svg')
      }
    }
  },
  computed: {
    tabLabels () {
      return Object.assign({
        tab1: 'ข้อมูลลูกค้า',
        tab2: 'โน้ต',
        tab3: 'บุ๊กมาร์ก',
        tab4: 'ผู้ช่วย AI'
      }, this.labels)
    }
  },
  methods: {
    isDisabled (n) {
      return this.disabledTabs.indexOf(n) !== -1
    },
    // The `disabled` attribute already blocks a real click; this stops a programmatic one too.
    onTab (n) {
      if (this.isDisabled(n)) return
      this.$emit('setTab', n)
    },
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    }
  }
}
</script>

<style scoped>
.v2026-panelbar-mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}

.v2026-panelbar-tabs {
  display: flex;
  flex: 0 0 auto;
  height: 52px;
  border-bottom: 1px solid var(--v2026-border);
  background: var(--v2026-surface);
}
.v2026-panelbar-tab {
  position: relative;
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  border-radius: var(--v2026-r-tab);
  cursor: pointer;
  transition: background 150ms ease;
}
.v2026-panelbar-tab:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}
.v2026-panelbar-tab__ico {
  width: 22px;
  height: 22px;
  background-color: var(--v2026-color-icon-idle);
}
.v2026-panelbar-tab.is-active {
  background: var(--v2026-color-main-soft);
}
.v2026-panelbar-tab.is-active .v2026-panelbar-tab__ico {
  background-color: var(--v2026-color-main);
}

.v2026-panelbar-tab.is-disabled {
  cursor: not-allowed;
  background: transparent;
}
.v2026-panelbar-tab.is-disabled .v2026-panelbar-tab__ico {
  background-color: var(--v2026-text-muted, #98a2b3);
  opacity: 0.6;
}
.v2026-panelbar-tab.is-active::after {
  content: '';
  position: absolute;
  left: 20%;
  right: 20%;
  bottom: 0;
  height: 2px;
  background: var(--v2026-color-main);
  border-radius: 2px 2px 0 0;
}
</style>
